import 'amfe-flexible';
import Vue from 'vue';
import App from './App';
import Element from 'element-ui'
import "element-ui/packages/theme-chalk/lib/index.css"
import { router } from './router';
import 'vant/lib/index.css';
import 'lib-flexible'
Vue.use(Element);
new Vue({
  router,
  Element,
  el: '#app',
  render: h => h(App)
});

